<template>
  <a
    :href="messengerHref"
    target="_blank"
    rel="noopener"
    class="msgr-float"
    aria-label="Messenger-এ মেসেজ করুন"
    @click="onClick"
  >
    <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor" aria-hidden="true">
      <path d="M12 2C6.21 2 1.6 6.37 1.6 12.05c0 3.18 1.45 6.02 3.72 7.86V24l3.4-1.87c.9.25 1.86.39 2.86.39 5.79 0 10.4-4.37 10.4-10.05S17.79 2 12 2zm1.05 13.5l-2.65-2.83-5.17 2.83 5.69-6.04 2.72 2.83 5.1-2.83-5.69 6.04z"/>
    </svg>
  </a>
</template>

<script>
import { computed } from 'vue';
import { trackMessengerChatClick } from "@/config/pixels";

export default {
  name: 'MessengerFloat',
  props: {
    // guideline key: bangla | english | bangladesh | international | ict
    subject: { type: String, required: true },
  },
  setup(props) {
    // Same canonical FB Page ID as GuidelineOptin; ref= carries the subject
    // so conversations are attributable (and ManyChat can route them later).
    const messengerHref = computed(
      () => `https://m.me/500734590359140?ref=${props.subject}_guideline`
    );
    const onClick = () => trackMessengerChatClick(props.subject);
    return { messengerHref, onClick };
  },
};
</script>

<style scoped>
.msgr-float {
  position: fixed; bottom: 24px; right: 22px; z-index: 1100;
  width: 56px; height: 56px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  background: linear-gradient(135deg, #00B2FF, #006AFF);
  color: #fff; text-decoration: none;
  box-shadow: 0 6px 20px rgba(0, 106, 255, 0.45);
  transition: transform 0.2s, box-shadow 0.2s;
}
.msgr-float:hover {
  transform: scale(1.08);
  box-shadow: 0 8px 26px rgba(0, 106, 255, 0.55);
}

/* keep clear of the mobile sticky opt-in bar (GuidelineOptin, z-index 1200) */
@media (max-width: 768px) {
  .msgr-float { bottom: 86px; right: 14px; width: 52px; height: 52px; }
}
</style>